import React, { useState } from 'react';
import { Alert, Button, Badge } from 'react-bootstrap';
import { FaExclamationTriangle, FaKey, FaEye, FaTimes } from 'react-icons/fa';
import { useLicense } from '../../context/LicenseContext';
import LicenseEntryModal from './LicenseEntryModal';

const ReadOnlyBanner = () => {
  const { licenseStatus, isReadOnlyMode, refreshLicenseStatus } = useLicense();
  const [showLicenseModal, setShowLicenseModal] = useState(false);
  const [dismissed, setDismissed] = useState(false);

  const handleLicenseUpdated = () => {
    setShowLicenseModal(false);
    refreshLicenseStatus();
    setDismissed(false); // Show banner again after license update
  };

  // Don't show banner if not in read-only mode or if dismissed
  if (!isReadOnlyMode() || dismissed) {
    return null;
  }

  return (
    <>
      <Alert 
        variant="warning" 
        className="mb-3 border-0"
        style={{ 
          position: 'sticky', 
          top: '0', 
          zIndex: 1000,
          borderRadius: '0',
          boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
        }}
      >
        <div className="d-flex align-items-center justify-content-between">
          <div className="d-flex align-items-center">
            <FaExclamationTriangle className="me-2 text-warning" size={20} />
            <div>
              <strong>Read-Only Mode Active</strong>
              <div className="small text-muted">
                {licenseStatus?.status === 'EXPIRED' ? (
                  <>Your license expired on {new Date(licenseStatus.expirationDate).toLocaleDateString()}. You can view existing data but cannot make changes.</>
                ) : (
                  <>No valid license found. You can view existing data but cannot make changes.</>
                )}
              </div>
            </div>
          </div>
          
          <div className="d-flex align-items-center gap-2">
            <Badge bg="secondary">
              <FaEye className="me-1" />
              Read-Only
            </Badge>
            
            <Button 
              variant="outline-primary"
              size="sm"
              onClick={() => setShowLicenseModal(true)}
            >
              <FaKey className="me-1" />
              Enter License
            </Button>
            
            <Button 
              variant="outline-secondary"
              size="sm"
              onClick={() => setDismissed(true)}
              title="Dismiss this banner"
            >
              <FaTimes />
            </Button>
          </div>
        </div>
      </Alert>
      
      <LicenseEntryModal 
        show={showLicenseModal}
        onHide={() => setShowLicenseModal(false)}
        onLicenseUpdated={handleLicenseUpdated}
        currentStatus={licenseStatus}
      />
    </>
  );
};

export default ReadOnlyBanner;
